import React, {Component} from 'react';
import {
  Row,
  Card,
  CardBody,
  Nav, NavItem, NavLink, TabContent, TabPane, CardTitle,
} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {Colxx} from '../../components/common/CustomBootstrap';
import NotificationsList from "../NotificationsList";
import classnames from "classnames";

class UserNotifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0,
    };
  }

  toggle = tabIndex => {
    this.setState({
      activeTab: tabIndex,
    });
  };

  render() {
    const {t, userId, history} = this.props;
    const {activeTab} = this.state;
    return (
      <Row>
        <Colxx xxs="12" className="mb-4">
          <Card className="h-100">
            <CardBody>
              <CardTitle className="text-large text-primary mb-5">
                {t('Notifications')}
              </CardTitle>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === 0 })}
                    onClick={() => {this.toggle(0);}}>
                    <span className="text-one cursor-pointer">{t('All')}</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === 1 })}
                    onClick={() => {this.toggle(1);}}>
                    <span className="text-one cursor-pointer">{t('Announcements')}</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === 2 })}
                    onClick={() => {this.toggle(2);}}>
                    <span className="text-one cursor-pointer">{t('Declarations')}</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === 3 })}
                    onClick={() => {this.toggle(3);}}>
                    <span className="text-one cursor-pointer">{t('Events')}</span>
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab}>
                <TabPane tabId={0}>
                  <NotificationsList
                    userId={userId}
                    showAllActions={false}
                    history={history}
                  />
                </TabPane>
                <TabPane tabId={1}>
                  <NotificationsList
                    userId={userId}
                    category="ANNOUNCEMENT"
                    showAllActions={false}
                    history={history}
                  />
                </TabPane>
                <TabPane tabId={2}>
                  <NotificationsList
                    userId={userId}
                    category="DECLARATION"
                    showAllActions={false}
                    history={history}
                  />
                </TabPane>
                <TabPane tabId={3}>
                  <NotificationsList
                    userId={userId}
                    category="EVENT"
                    showAllActions={false}
                    history={history}
                  />
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }
}

export default withTranslation()(UserNotifications);
